import {useLazyQuery} from "@apollo/client";
import isFunction from "lodash/isFunction";
import {ForwardedRef, forwardRef} from "react";
import {toast} from "react-hot-toast";
import {SelectInstance} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectProps} from "@/components/select/Select.types.ts";
import {FindCheckOrStatusPageResult, GQL_FIND_CHECK_OR_STATUS_PAGE, WidgetEntity} from "@/lib/queries/statuspages.ts";

export const WidgetEntitySelect = forwardRef(
  ({onChange, ...props}: SelectProps<WidgetEntity>, ref: ForwardedRef<SelectInstance<WidgetEntity>>) => {
    const [searchItems] = useLazyQuery<FindCheckOrStatusPageResult>(GQL_FIND_CHECK_OR_STATUS_PAGE);
    const loadOptions = (query: string, callback: (options: WidgetEntity[]) => void) => {
      searchItems({
        variables: {
          search: query,
          limit: 50,
        },
      }).then((result) => {
        if (result.error) {
          console.log(result.error);
          toast.error("Oops... Something went wrong. Please try again.");
          return [];
        }

        callback(result.data?.items || []);
        if (result.data && result.data?.items.length > 0 && isFunction(onChange)) {
          onChange(result.data.items[0], {action: "select-option", option: result.data.items[0]});
        }
      });
    };

    return (
      <Select
        ref={ref}
        async={true}
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        onChange={onChange}
        getOptionValue={(c) => c.id.toString()}
        getOptionLabel={(c) => {
          if (c.type === "CHECK") {
            return `Check: ${c.name}`;
          }
          return `Status Page: ${c.name}`;
        }}
        {...props}
      />
    );
  }
);
